import 'css-chunksrc/client/scenes/task/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_cqdw9_1",
  "contextualMenu": "_contextualMenu_cqdw9_6",
  "contextualMenuMultiProject": "_contextualMenuMultiProject_cqdw9_12",
  "dates": "_dates_cqdw9_16",
  "row": "_row_cqdw9_20",
  "date": "_date_cqdw9_16"
};